import * as TYPES from './mutationTypes'

export default {
  //列表
  [TYPES.GET_SPV_LIGHT_NODES](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      spv_light_nodes_list: payload.result.items,
      spv_light_nodes_paging: { limit, offset, total }
    })
  }
}
